import React, {useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {adminUiTexts} from 'data/ui-texts/admin-ui-texts';
import { sortArrayByProperty } from 'helpers/array-helper';
import AdminTextToSpeechPopup from './admin-text-to-speech-popup/admin-text-to-speech-popup';
import Button from 'components/ui/button/button';
import 'react-datepicker/dist/react-datepicker.css';
import './admin.scss';

const Admin = ({languageId, authData, handleLogout}) => {

	const unsubscribeTickets = useRef(null);

	const [showTextToSpeechPopup, setShowTextToSpeechPopup] = useState(false);

	const [tickets, setTickets] = useState([]);

	/* Start and end date ids */
	const defaultStartDate = dayjs(new Date()).subtract(1, 'week').format('YYYYMMDD');
	const [startDate, setStartDate] = useState(defaultStartDate);
	const [endDate, setEndDate] = useState(dayjs(new Date()).format('YYYYMMDD'));

	const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
	const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');		
	const filteredTickets = tickets.filter((ticket) => {			
		return (
			dayjs(ticket.submitted).format('YYYY-MM-DD') >= formattedStartDate &&
			dayjs(ticket.submitted).format('YYYY-MM-DD') <= formattedEndDate
		);
	});
	
	
	const sortedTickets = sortArrayByProperty(filteredTickets, 'submitted', 'DESC');
	
	/**
	 * Subscribe to lottery tickets
	 */
	const subscribeToLotteryTickets = () => {
		if (unsubscribeTickets.current) unsubscribeTickets.current();

		return new Promise((resolve) => {
			const db = firebase.firestore();
			unsubscribeTickets.current = db.collection(appConfig.ticketsDbName).onSnapshot((querySnapshot) => {
				let tickets = [];
				querySnapshot.forEach((doc) => {tickets.push({id: doc.id, ...doc.data()});});
				setTickets(tickets);
				resolve({status: 'success'});
			},
			(error) => {
				console.error('could not get games: ', error);
				resolve({status: 'error', error: error});
			}
			);
		});
	};

	/**
	 * Component mounted / will unmount
	 */
	useEffect(() => {
		subscribeToLotteryTickets();
		
		/* Component will ummount */
		return () => {
			/* Remove event listeners for window size, orientation & touch start */
			if (unsubscribeTickets.current) {
				unsubscribeTickets.current();
			}
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="Admin">
			<div className="Admin-header">
				<div className="Admin-headerTitle">
					<span>{getText(adminUiTexts.admin, languageId)}</span>
				</div>
				<div className="Admin-logoutBtn">
					<Button 
						classes={['logout']} 
						text={getText(adminUiTexts.logout, languageId)} 
						onClick={() => {handleLogout();}} 
					/>
				</div>
			</div>
			<div className="Admin-content">
				<div className="Admin-textToSpeechBtn">
					<Button 
						classes={['blue', 'fullWidth']} 
						text={getText(adminUiTexts.textToSpeechPopup.title, languageId)} 
						onClick={() => {setShowTextToSpeechPopup(true);}} 
					/>
				</div>

				<div className="Admin-lottery">
					<div className="Admin-lotteryTitle">
						<span>{getText(adminUiTexts.lottery, languageId)}</span>
					</div>
					<div className="Admin-dateFilter">
						<DatePicker
							disabled={false}
							selected={startDate ? dayjs(startDate).toDate() : new Date()}
							onChange={(date) => {setStartDate(dayjs(date).format('YYYYMMDD'));}}
							locale={'da'}
							dateFormat="dd/MM-yyyy"
							placeholderText="dd/MM-yyyy"
						/>
						<div className="Admin-periodTo"><span>-</span></div>
						<DatePicker
							disabled={false}
							selected={endDate ? dayjs(endDate).toDate() : new Date()}
							onChange={(date) => {setEndDate(dayjs(date).format('YYYYMMDD'));}}
							locale={'da'}
							dateFormat="dd/MM-yyyy"
							placeholderText="dd/MM-yyyy"
						/>
					</div>
					<div className="Admin-tickets">
						<div className="Admin-ticketRow header">
							<div className="Admin-ticketCell email">
								<span>{getText(adminUiTexts.email, languageId)}</span>
							</div>
							<div className="Admin-ticketCell newsletter">
								<span>{getText(adminUiTexts.newsletter, languageId)}</span>
							</div>
							<div className="Admin-ticketCell date">
								<span>{getText(adminUiTexts.submitted, languageId)}</span>
							</div>
						</div>
						{sortedTickets.map((ticket, index) => {
							return (
								<div key={index} className="Admin-ticketRow body">
									<div className="Admin-ticketCell email">
										<span>{ticket.email}</span>
									</div>
									<div className={'Admin-ticketCell newsletter' 
											+ (ticket.joinedNewsletter ? ' checked' : '')}>
									</div>
									<div className="Admin-ticketCell date">
										<span>{ticket.submitted}</span>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>

			{showTextToSpeechPopup && <AdminTextToSpeechPopup 
				languageId={languageId}
				togglePopup={() => {setShowTextToSpeechPopup(false);}}
			/>}
		</div>
	);

};

Admin.propTypes = {
	languageId: PropTypes.string.isRequired,
	authData: PropTypes.object.isRequired,
	handleLogout: PropTypes.func.isRequired
};

export default Admin;
